import { render, staticRenderFns } from "./ExportData.vue?vue&type=template&id=5f85ed6e&"
import script from "./ExportData.vue?vue&type=script&lang=js&"
export * from "./ExportData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports